import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['allCheckbox', 'agentCheckbox', 'checkmark', 'agentSelection']

  connect() {
    this.toggleAgentSelection()
  }

  toggleAgentSelection() {
    const createForAll = this.allCheckboxTarget.checked

    if (createForAll) {
      // Hide individual checkboxes, show checkmarks, uncheck individuals
      this.agentCheckboxTargets.forEach((checkbox) => {
        checkbox.classList.add('hidden')
        checkbox.checked = false
      })
      this.checkmarkTargets.forEach((checkmark) => {
        checkmark.classList.remove('hidden')
      })
      // Hide legacy agentSelection container if present
      if (this.hasAgentSelectionTarget) {
        this.agentSelectionTarget.classList.add('hidden')
      }
    } else {
      // Show individual checkboxes, hide checkmarks
      this.agentCheckboxTargets.forEach((checkbox) => {
        checkbox.classList.remove('hidden')
      })
      this.checkmarkTargets.forEach((checkmark) => {
        checkmark.classList.add('hidden')
      })
      // Show legacy agentSelection container if present
      if (this.hasAgentSelectionTarget) {
        this.agentSelectionTarget.classList.remove('hidden')
      }
    }
  }
}
